import React from 'react';
import { Close } from '@mui/icons-material';
import { Menu, Box, Typography } from '@mui/material';
import theme from '../../constants/theme';
import { t } from '../../utils/translate';
import { FilledButtonStyled } from '../button/filledButtonStyled';
import { device } from '../../constants/devices';

type Props = {
  width: number;
  anchorEl: HTMLElement | null;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export const GoogleMapsCookie = ({
  width,
  anchorEl,
  setAnchorEl,
  onClick,
}: Props) => (
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={() => setAnchorEl(null)}
    transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    PaperProps={{
      sx: {
        margin: 0,
        background: `${theme.palette.secondary.main} !important`,
        maxWidth: 'none !important',
        width: `${width}px`,
      },
    }}
    sx={{
      marginTop: '24px',
      '.MuiBackdrop-root': {
        background: 'none !important',
      },
      '.MuiMenu-list': { padding: 0 },
      [device.mobile]: {
        marginTop: 0,
        background: 'rgba(51, 51, 51, 0.70)',
      },
    }}
  >
    <Box padding="24px">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb="20px"
      >
        <Typography variant="h3" color="primary">
          Google Maps Cookie
        </Typography>

        <Box
          position="relative"
          bottom="8px"
          onClick={() => setAnchorEl(null)}
          sx={{ cursor: 'pointer' }}
        >
          <Close sx={{ color: theme.palette.primary.main }} />
        </Box>
      </Box>

      <Typography variant="subtitle1" color={theme.palette.text.secondary}>
        {t(
          'Um Ihnen eine schnellere Standortsuche zu ermöglichen, verwenden' +
            ' wir Daten von Google Maps. Um fortzufahren, müssen Sie der' +
            ' Verwendung von Google Maps zustimmen.'
        )}
      </Typography>

      <Box mt="30px">
        <FilledButtonStyled onClick={onClick}>
          {t('Aktivieren')}
        </FilledButtonStyled>
      </Box>
    </Box>
  </Menu>
);
